import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Loader2, Users, Flag } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';
import { ManualLayout } from '@/components/manual/ManualLayout';
import { OFFICIALS_MANUAL_SECTIONS } from '@/data/officialsManualContent';

const JumpCard = ({ href, icon: Icon, title, text, testId }) => (
  <a href={href} className="flex-1 min-w-[220px] rounded-2xl border bg-white px-4 py-3 hover:border-[#00247D] transition-colors no-underline print:hidden" data-testid={testId}>
    <div className="flex items-center gap-2 font-bold text-[#00247D]"><Icon className="w-4 h-4" />{title}</div>
    <p className="text-xs text-slate-500 mt-0.5">{text}</p>
  </a>
);

// Officials Scheduling add-on manual (/manual/officials). Signed-in users only.
export default function OfficialsManual() {
  const { isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (!loading && !isAuthenticated) navigate(`/login?redirect=${encodeURIComponent(location.pathname + location.hash)}`, { replace: true });
  }, [loading, isAuthenticated, navigate, location.pathname, location.hash]);
  if (loading || !isAuthenticated) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-slate-400" /></div>;
  return (
    <ManualLayout
      sections={OFFICIALS_MANUAL_SECTIONS}
      title="Officials Manual"
      subtitle="Scheduling, availability and payments for game officials, from setup to payday."
      updated="Jun 2026"
      badge="OFFICIALS MANUAL"
      back={{ to: '/officials', label: 'Back to Officials' }}
      seo={{ title: 'Officials Manual | Schedule Guru', description: 'How to use the Schedule Guru Officials Scheduling add-on.', path: '/manual/officials', noindex: true }}
    >
      <div className="flex flex-wrap gap-3 mt-5">
        <JumpCard href="#org-overview" icon={Users} title="For organizers & schedulers" text="Set up, assign officials, track availability and pay them." testId="manual-jump-organizers" />
        <JumpCard href="#off-joining" icon={Flag} title="For officials" text="Join a league, answer assignments, set availability, see earnings." testId="manual-jump-officials" />
      </div>
      <p className="text-xs text-slate-500 mt-3 print:hidden">Looking for the rest of Schedule Guru? Open the <Link to="/manual" className="text-[#00247D] underline">main user manual</Link>.</p>
    </ManualLayout>
  );
}
